SupportEmailFormUSMainView = require('../../email_form/US/main_view')
SharedFooterUSPhoneNumberView = require('../../../../../shared/frontend/views/footer/US/phone_number_view')
SupportPhoneNumberCallBackView = require('../../email_form/US/phone_number_call_back_view')
SupportV1StepThreeBaseView = require('../v1_base_view')
SupportEmailFormUSV2FlexibleContactChannelsView = require('../../email_form/US/v2_flexible_contact_channels')

class SupportV2USStepThreeView extends SupportV1StepThreeBaseView

  getEmailFormView: (options) ->
    new SupportEmailFormUSMainView(options)

  renderPhoneNumberView: ->
    if window.evaluate(experiments?.shouldDisplayCallBackOption)
      @renderPhoneNumberCallBackView()
    else
      @renderNormalPhoneNumberView()

  renderNormalPhoneNumberView:()->
    propagateEventBeforeReplacingElements( () ->
      phoneNumberView = new SharedFooterUSPhoneNumberView()
      phoneNumberView.render()
    )

  renderPhoneNumberCallBackView:()->
    propagateEventBeforeReplacingElements( () =>
      @phoneNumberCallBackView = new SupportPhoneNumberCallBackView
                                  mainView: this
      @phoneNumberCallBackView.render()
    )

  shouldShowContactChannelView: ->
    window.evaluate(window.experiments?.showFlexibleContactChannels)

  configureContactChannelView: (options) ->
    new SupportEmailFormUSV2FlexibleContactChannelsView(options)

  renderContactChannelView: () ->
    SupportV1StepThreeBaseView::renderContactChannelView.apply(this, arguments)

    hideInbentaResults = () =>
      inbentaResults =  $("#results:visible")
      if inbentaResults.length > 0
        inbentaResults.hide()
        clearInterval(@hideInbentaResultsInterval)
    @hideInbentaResultsInterval = setInterval(hideInbentaResults, 0)

  renderEmailForm: () ->
    if @hideInbentaResultsInterval
      clearInterval(@hideInbentaResultsInterval)
    SupportV1StepThreeBaseView::renderEmailForm.apply(this, arguments)

  postEmailFormRenderCallBack: ->
    Groupon.Support.ContentModel.onInitStepThree()

module.exports = SupportV2USStepThreeView

